<app-print-layout (cancelar)="cancelar()" [printBodyClass]="'print-a3-landscape'">
  <div *ngIf="dados" style="padding: 18px !important;" class="conteudo-impressao">
    <h4 class="mb-3">Mapeamento de Processo, Riscos e Controles Associados</h4>

    <p><strong>Unidade auditada:</strong> {{ nomeUnidadeGestora }}</p>
    <p><strong>Processo de Trabalho Auditado:</strong> {{ dados.nomeProcesso }}</p>

    <div class="table-responsive mt-4">
      <table class="table table-bordered table-sm">
        <thead>
          <tr class="bg-dark text-white text-center">
            <th colspan="4" class="bg-warning">ATIVIDADE</th>
            <th class="bg-orange" [attr.colspan]="4 + listEscalas.length">RISCOS</th>
            <th colspan="5" class="bg-info">CONTROLES</th>
            <th colspan="3" class="bg-success">TESTES</th>
          </tr>
          <tr class="text-center">
            <!-- Atividade -->
            <th>Ref</th>
            <th>Descrição <br> da Atividade <br> (O quê?)</th>
            <th>Responsável (Quem?)</th>
            <th>Como</th>
            <!-- Riscos -->
            <th data-col="descricao-risco">Descrição</th>
            <th>Causa Risco</th>
            <th>Consequência</th>
            <ng-container *ngFor="let escala of listEscalas">
              <th>{{ escala.nome }}</th>
            </ng-container>
            <th>Nível <br> de Risco <br> Inerente (RI)</th>
            <!-- Controles -->
            <th data-col="descricao-controle" class="col-descricao-controle">Descrição <br> do Controle <br>Verificado
            </th>
            <th>Avaliação</th>
            <th>Risco de<br>Controle<br>(RC)</th>
            <th>Risco Residual<br>(RR = RI x RC)</th>
            <th>Melhor Prática</th>
            <!-- Testes -->
            <th>Prioridade</th>
            <th>Tipo de Teste</th>
            <th class="col-questao">Questão</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let atividade of dados.atividades; let atIndex = index">
            <ng-container *ngFor="let risco of getRiscosPorAtividade(atividade.id); let rIndex = index">
              <ng-container *ngFor="let associado of getAssociadosPorRisco(risco.id); let aIndex = index">
                <ng-container *ngFor="let teste of getTestesPorAssociado(associado.id); let tIndex = index">
                  <tr>
                    <!-- ATIVIDADE - Só exibe na primeira linha de cada atividade -->
                    <ng-container *ngIf="rIndex === 0 && aIndex === 0 && tIndex === 0">
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">
                        AT{{ formatarRef(atividade.posicao) }}
                      </td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.descricao }}</td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.responsavel }}</td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.comoRealizada }}</td>
                    </ng-container>

                    <!-- RISCO - Só exibe na primeira linha de cada risco -->
                    <ng-container *ngIf="aIndex === 0 && tIndex === 0">
                      <td data-col="descricao-risco" [attr.rowspan]="getTotalLinhasPorRisco(risco.id)">{{
                        risco.descricaoRisco }}
                      </td>
                      <!-- CAUSA RISCO - Com centralização e caixa padronizada -->
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)" class="text-center">
                        <div *ngIf="risco.causas?.length > 0; else semCausa">
                          <div *ngFor="let causa of risco.causas" class="item-lista-risco">
                            {{ causa.descricao }}
                          </div>
                        </div>
                        <ng-template #semCausa>
                          <div class="item-lista-risco">—</div>
                        </ng-template>
                      </td>
                      <!-- CONSEQUÊNCIA - Com centralização e caixa padronizada -->
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)" class="text-center">
                        <div *ngIf="risco.consequencias?.length > 0; else semConsequencia">
                          <div *ngFor="let cons of risco.consequencias" class="item-lista-risco">
                            {{ cons.descricao }}
                          </div>
                        </div>
                        <ng-template #semConsequencia>
                          <div class="item-lista-risco">—</div>
                        </ng-template>
                      </td>
                      <ng-container *ngFor="let escala of listEscalas">
                        <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)" data-col="descricao-default">
                          {{ getMagnitudeValue(risco, escala) }}
                        </td>
                      </ng-container>
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id) " data-col="descricao-default">{{
                        risco.resultadoRI }} ({{ risco.nivelRI }}
                        )
                      </td>
                    </ng-container>

                    <!-- CONTROLES - Só exibe na primeira linha de cada controle -->
                    <ng-container *ngIf="tIndex === 0">
                      <td data-col="descricao-controle" class="col-descricao-controle"
                        [attr.rowspan]="getTotalLinhasPorAssociado(associado.id)">{{ associado.descricao || '—'
                        }}
                      </td>
                      <td data-col="avaliacao" [attr.rowspan]="getTotalLinhasPorAssociado(associado.id)"> {{
                        associado.descricaoControle || '—' }}
                      </td>
                      <td data-col="risco-rc" [attr.rowspan]="getTotalLinhasPorAssociado(associado.id)">{{
                        associado.valorRI || '—' }}</td>
                      <td data-col="risco-rr" [attr.rowspan]="getTotalLinhasPorAssociado(associado.id)"> {{
                        associado.valorCalculado || '—' }}
                        ({{ associado.nivelRR }})
                      </td>
                      <td [attr.rowspan]="getTotalLinhasPorAssociado(associado.id)">{{ associado.descricaoMelhorPratica
                        || '—' }}
                      </td>
                    </ng-container>

                    <!-- TESTES - Sempre exibe (uma linha por teste) -->
                    <td>{{ teste.prioridade }}</td>
                    <td>{{ teste.tipoTeste }}</td>
                    <td class="col-questao">
                      <ng-container *ngIf="teste.realizarTestes === false; else comTestes">
                        Não serão realizados testes/Não incluído no escopo da auditoria. {{ teste.justificativa }}
                      </ng-container>
                      <ng-template #comTestes>
                        <ul *ngIf="teste.questoes?.length > 0" style="margin: 0; padding-left: 1rem;">
                          <li *ngFor="let q of teste.questoes">
                            {{ q.ordem ? q.ordem + ' - ' : '' }}{{ q.nomeQuestao || '—' }}
                          </li>
                        </ul>
                        <span *ngIf="!teste.questoes?.length">—</span>
                      </ng-template>
                    </td>
                  </tr>
                </ng-container>

                <!-- Se não há testes para o associado, criar uma linha em branco para mostrar o controle -->
                <ng-container *ngIf="getTestesPorAssociado(associado.id).length === 0">
                  <tr>
                    <!-- ATIVIDADE - Só exibe na primeira linha de cada atividade -->
                    <ng-container *ngIf="rIndex === 0 && aIndex === 0">
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">
                        AT{{ formatarRef(atividade.posicao) }}
                      </td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.descricao }}</td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.responsavel }}</td>
                      <td [attr.rowspan]="getTotalLinhasPorAtividade(atividade.id)">{{ atividade.comoRealizada }}</td>
                    </ng-container>

                    <!-- RISCO - Só exibe na primeira linha de cada risco -->
                    <ng-container *ngIf="aIndex === 0">
                      <td data-col="descricao-risco" [attr.rowspan]="getTotalLinhasPorRisco(risco.id)">{{
                        risco.descricaoRisco }}
                      </td>
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)" class="text-center">
                        <div *ngIf="risco.causas?.length > 0; else semCausa2">
                          <div *ngFor="let causa of risco.causas" class="item-lista-risco">
                            {{ causa.descricao }}
                          </div>
                        </div>
                        <ng-template #semCausa2>
                          <div class="item-lista-risco">—</div>
                        </ng-template>
                      </td>
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)" class="text-center">
                        <div *ngIf="risco.consequencias?.length > 0; else semConsequencia2">
                          <div *ngFor="let cons of risco.consequencias" class="item-lista-risco">
                            {{ cons.descricao }}
                          </div>
                        </div>
                        <ng-template #semConsequencia2>
                          <div class="item-lista-risco">—</div>
                        </ng-template>
                      </td>
                      <ng-container *ngFor="let escala of listEscalas">
                        <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)">
                          {{ getMagnitudeValue(risco, escala) }}
                        </td>
                      </ng-container>
                      <td [attr.rowspan]="getTotalLinhasPorRisco(risco.id)">{{ risco.resultadoRI }} ({{ risco.nivelRI }}
                        )
                      </td>
                    </ng-container>

                    <!-- CONTROLES - Sempre exibe quando não há testes -->
                    <td data-col="descricao-controle" class="col-descricao-controle"> {{ associado.descricao || '—' }}
                    </td>
                    <td data-col="avaliacao">
                      {{ associado.descricaoControle || '—' }}
                    </td>
                    <td>{{ associado.valorRI || '—' }}
                    </td>
                    <td>{{ associado.valorCalculado || '—' }} ({{ associado.nivelRR }})</td>
                    <td>{{ associado.descricaoMelhorPratica || '—' }}</td>

                    <!-- TESTES - Colunas vazias -->
                    <td>—</td>
                    <td>—</td>
                    <td class="col-questao">—</td>
                  </tr>
                </ng-container>
              </ng-container>

              <!-- CASO ESPECIAL: Se um risco não tem associados, ainda precisa aparecer -->
              <ng-container *ngIf="getAssociadosPorRisco(risco.id).length === 0">
                <tr>
                  <td data-col="descricao-risco">{{ risco.descricaoRisco }}</td>
                  <td class="text-center">
                    <div *ngIf="risco.causas?.length > 0; else semCausa3">
                      <div *ngFor="let causa of risco.causas" class="item-lista-risco">
                        {{ causa.descricao }}
                      </div>
                    </div>
                    <ng-template #semCausa3>
                      <div class="item-lista-risco">—</div>
                    </ng-template>
                  </td>
                  <td class="text-center">
                    <div *ngIf="risco.consequencias?.length > 0; else semConsequencia3">
                      <div *ngFor="let cons of risco.consequencias" class="item-lista-risco">
                        {{ cons.descricao }}
                      </div>
                    </div>
                    <ng-template #semConsequencia3>
                      <div class="item-lista-risco">—</div>
                    </ng-template>
                  </td>
                  <ng-container *ngFor="let escala of listEscalas">
                    <td data-col="descricao-default">{{ getMagnitudeValue(risco, escala) }}</td>
                  </ng-container>
                  <td data-col="descricao-default">{{ risco.resultadoRI }} ({{ risco.nivelRI }})</td>

                  <!-- CONTROLES - Colunas vazias -->
                  <td data-col="descricao-controle" class="col-descricao-controle">—
                  </td>
                  <td data-col="avaliacao">—</td>
                  <td data-col="risco-rc">—</td>
                  <td data-col="risco-rr">—</td>
                  <td>—</td>

                  <!-- TESTES - Colunas vazias -->
                  <td>—</td>
                  <td>—</td>
                  <td class="col-questao">—</td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- CASO ESPECIAL: Se uma atividade não tem riscos, ainda precisa aparecer -->
            <ng-container *ngIf="getRiscosPorAtividade(atividade.id).length === 0">
              <tr>
                <!-- ATIVIDADE - Sempre exibe pois esta atividade não tem riscos -->
                <td>AT{{ formatarRef(atividade.posicao) }}</td>
                <td>{{ atividade.descricao }}</td>
                <td>{{ atividade.responsavel }}</td>
                <td>{{ atividade.comoRealizada }}</td>

                <!-- RISCOS - Colunas vazias -->
                <td>—</td>
                <td>—</td>
                <td>—</td>
                <ng-container *ngFor="let escala of listEscalas">
                  <td>—</td>
                </ng-container>
                <td>—</td>

                <!-- CONTROLES - Colunas vazias -->
                <td data-col="descricao-controle" class="col-descricao-controle">—</td>
                <td>—</td>
                <td>—</td>
                <td>—</td>
                <td>—</td>

                <!-- TESTES - Colunas vazias -->
                <td>—</td>
                <td>—</td>
                <td class="col-questao">—</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</app-print-layout>